export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/upload.worker.a9ed3972.worker.js");
}
